export interface FlightSearchDisplayTextParams {
  originAirportCode: string
  destinationAirportCode: string
  departureDate: string
  returnDate?: string
  fareClass?: string
  fareType?: string
  occupants?: App.Occupants
  itinerary?: ReadonlyArray<{ departureAirport: string, arrivalAirport: string, departureDate: string }>
}

// Shared by both the activity entry (`flight_search_submitted`) and the committed-state entry
// (`last_flight_search`) -- same underlying search, same customer-facing summary, so one composer
// rather than two copies that could silently drift apart.
export function formatFlightSearchDisplayText({
  originAirportCode,
  destinationAirportCode,
  departureDate,
  returnDate,
  fareClass,
  fareType,
  occupants,
  itinerary,
}: FlightSearchDisplayTextParams): string {
  const route = itinerary && itinerary.length > 1
    ? itinerary.map(leg => `${leg.departureAirport}-${leg.arrivalAirport} ${leg.departureDate}`).join('; ')
    : `${originAirportCode}-${destinationAirportCode} ${departureDate}${returnDate ? ` return ${returnDate}` : ''}`
  return [
    fareType,
    route,
    fareClass,
    occupants && `${occupants.adults} adults, ${occupants.children ?? 0} children, ${occupants.infants ?? 0} infants`,
  ].filter(Boolean).join('; ')
}
